import TrackedExtLinkButton from '../Button/TrackedExtLinkButton';

function UpgradeToSpateProLink(props) {
    return (
        <TrackedExtLinkButton
            variant="default"
            href="https://www.spate.nyc/trial?utm_source=spate_dashboard&utm_medium=referral&utm_campaign=no_tiktok_access"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-2"
            {...props}
        >
            Upgrade to Spate Pro
        </TrackedExtLinkButton>
    );
}

export default UpgradeToSpateProLink;
